"use client";

import { ArrowLeft, RotateCw, TriangleAlert } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";

import { DEFAULT_POST_LANGUAGE } from "@/lib/post-language";
import { getFeedPath, parsePostLanguageFromPathname } from "@/lib/post-routes";
import { getPublicVocabulary } from "@/lib/public-vocabulary";
import {
  PUBLIC_STATUS_ACTION_CLASS,
  PUBLIC_STATUS_SECONDARY_ACTION_CLASS,
  PublicStatusPanel,
} from "@/components/public-status-panel";

type PublicErrorViewProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export function PublicErrorView({ error, reset }: PublicErrorViewProps) {
  const pathname = usePathname();
  const language = parsePostLanguageFromPathname(pathname ?? "") ?? DEFAULT_POST_LANGUAGE;
  const copy = getPublicVocabulary(language).status;
  // Il digest e l'unico dettaglio mostrabile: il messaggio dell'errore in
  // produzione e oscurato da Next e puo contenere dati interni.
  const detail = error.digest ? copy.errorDigest(error.digest) : null;

  return (
    <>
      {/* error.tsx e un client component e non puo esportare `metadata`: il tag
          viene issato in <head> da React. */}
      <meta name="robots" content="noindex, nofollow" />
      <PublicStatusPanel
        tone="alert"
        eyebrow={copy.errorEyebrow}
        icon={<TriangleAlert className="h-6 w-6" aria-hidden="true" />}
        title={copy.errorTitle}
        description={copy.errorDescription}
        detail={detail}
      >
        <button type="button" onClick={reset} className={PUBLIC_STATUS_ACTION_CLASS}>
          <RotateCw className="h-4 w-4" aria-hidden="true" />
          {copy.retry}
        </button>
        <Link href={getFeedPath(language)} className={PUBLIC_STATUS_SECONDARY_ACTION_CLASS}>
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          {copy.backToFeed}
        </Link>
      </PublicStatusPanel>
    </>
  );
}
